import AuthorizedApiClient from '@/modules/auth/models/authorizedApiClient';

const blobUrlByToken = new Map<string, string>();
const inflightByToken = new Map<string, Promise<string | null>>();

/**
 * Fetch GET /file/{token} once per token (deduped), return blob: URL for <img> etc.
 * Revoke via revokeAllFileDisplayCache on logout.
 */
export async function getCachedFileBlobUrl(fileToken: string): Promise<string | null> {
  const token = String(fileToken).trim();
  if (!token) {
    return null;
  }

  const cached = blobUrlByToken.get(token);
  if (cached) {
    return cached;
  }

  const inflight = inflightByToken.get(token);
  if (inflight) {
    return inflight;
  }

  const promise = (async (): Promise<string | null> => {
    try {
      const response = await AuthorizedApiClient.get(`/file/${token}`, {
        responseType: 'blob',
      });
      const mime =
        (response.headers['content-type'] as string) || 'application/octet-stream';
      const url = URL.createObjectURL(new Blob([response.data], { type: mime }));
      blobUrlByToken.set(token, url);
      return url;
    } catch (e) {
      console.error('Error fetching file for display:', e);
      return null;
    } finally {
      inflightByToken.delete(token);
    }
  })();

  inflightByToken.set(token, promise);
  return promise;
}

export function invalidateFileDisplayCacheToken(fileToken: string): void {
  const token = String(fileToken).trim();
  const url = blobUrlByToken.get(token);
  if (url) {
    URL.revokeObjectURL(url);
    blobUrlByToken.delete(token);
  }
}

export function revokeAllFileDisplayCache(): void {
  blobUrlByToken.forEach((url) => {
    URL.revokeObjectURL(url);
  });
  blobUrlByToken.clear();
  inflightByToken.clear();
}
